import Layout from "layouts";
import React from "react";
import ForgotPasswordComponent from "./ForgotPasswordComponent";

export default function ForgotPassword() {
  return (
    <Layout noHeader maxWidth="xs">
      <ForgotPasswordComponent />
    </Layout>
  );
}
